var lastScrollTop = 0;
var start = document.getElementById('arriveInput').value;
var end = document.getElementById('departureInput').value;
var opened = 0 ;

const headerLogo = document.querySelector('.js-scroll-logo');
const resortsTab = document.querySelector('.js-resorts-tab');
const resortsPopup = document.getElementById('js-resorts-popup');
const bookingBtn = document.getElementById('js-booking-trigger');
const booking = document.getElementById('booking');
const closeBooking = document.getElementById('js-close-booking');
const burgerMenuBtn = document.getElementById('js-menu-trigger');
const burgerMenuClose = document.getElementById('js-close-menu');
const burgerMenu = document.getElementById('burger-menu');

(function(){

	document.addEventListener("DOMContentLoaded", function(event) {
		window.onload = onLoad();
	});

	// Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	if(resortsTab){
		resortsTab.addEventListener('mouseover', function () {
			resortsPopup.classList.add('open');
		});
		document.getElementById('js-resorts-close').addEventListener('click', function () {
			resortsPopup.classList.remove('open');
		});
	}

	if(bookingBtn) {
		bookingBtn.addEventListener('click', () => {
			booking.classList.add('open');
			document.body.classList.add('no-scroll');
		});

		closeBooking.addEventListener('click', () => {
			booking.classList.remove('open');
			document.body.classList.remove('no-scroll');
		});
	}

	if(burgerMenuBtn) {
		burgerMenuBtn.addEventListener('click', () =>{
			burgerMenu.classList.add('open');
			document.body.classList.add('no-scroll');
		});

		burgerMenuClose.addEventListener('click', () =>{
			burgerMenu.classList.remove('open');
			document.body.classList.remove('no-scroll');
		});
	}

	//Main Nav dropdown
	const listItems = document.querySelectorAll("#primary-nav li");

	listItems.forEach(function (listItem) {
		listItem.addEventListener("mouseenter", function () {
			const submenu = this.querySelector("ul.submenu");
			const resortsLink = this.querySelector(".js-resorts-tab");
			if (submenu) {
				submenu.style.display = "block";
			}
			if(!resortsLink && resortsPopup) {
				resortsPopup.classList.remove('open');
			}
		});
		listItem.addEventListener("mouseleave", function () {
			const submenu = this.querySelector("ul.submenu");
			if (submenu) {
				submenu.style.display = "none";
			}
		});
	});


	//// Forms animation for labels
	//email signup animation
	if (document.getElementById('email-signup_email_address')) {
		document.getElementById('email-signup_email_address').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_FNAME')) {
		document.getElementById('email-signup_FNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_LNAME')) {
		document.getElementById('email-signup_LNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_zip')) {
		document.getElementById('email-signup_zip').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}

	//CMS forms label animation
	if (document.getElementsByClassName('form-module__field').length > 0) {
		const MODULE_FIELDS = document.querySelectorAll('.form-module__field');
		MODULE_FIELDS.forEach((field) => {
			if (field.getElementsByTagName('input').length > 0) {
				if (field.getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					field.getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					});
				}
			}
			if (field.getElementsByTagName('select').length > 0) {
				field.getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
			if (field.getElementsByTagName('textarea').length > 0) {
				field.getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
		});
	}

	//vanilla JS fancybox
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				document.getElementById(currentTarget).classList.add('open');
				document.body.classList.add('no-scroll');
			});
		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				document.getElementById(currentTarget).classList.remove('open');
				document.body.classList.remove('no-scroll');
			});
		}
	}

	setUpBooking();

	document.getElementById('booking-form').bookingID.onchange = function() {
		var newaction = this.value;
		document.getElementById('hotel').value = newaction;
	};

	$('.sym-slides').slick({
        accessibility: false
    });

	const swiperADAduplicatedProcess = (currentSwiper) => {
		currentSwiper.slides.forEach((slide) => {
			if (slide.classList.contains('swiper-slide-duplicate')) {
				slide.setAttribute('aria-hidden', true);
				slide.setAttribute('tabindex', '-1');

				// REMOVE IDs
				slide.querySelectorAll('[id]').forEach((elementWithID) => {
					elementWithID.setAttribute('id', '');
				});

				// SET TABINDEXs -1
				slide.querySelectorAll('a').forEach((elementWithID) => {
					elementWithID.setAttribute('tabindex', '-1');
				});
			}
		});

		currentSwiper.el.querySelectorAll('.swiper-slide .swiper-pagination-bullet').forEach((dotInSlide) => {
			dotInSlide.setAttribute('tabindex', '-1');
		});
	};

	// SWIPER
	const swiperClass = '.swiper-js';

	document.querySelectorAll(swiperClass).forEach((slider, i) => {
		const dataOps = slider.dataset.swiper ? JSON.parse(slider.dataset.swiper) : {};

		const swiperOps = {
			speed: 1000,
			loop: true,
			fadeEffect: { crossFade: true },
			allowTouchMove: true,
			breakpoints: {
				767: {
					allowTouchMove: false,
				},
			},
			on: {
				init: function (currentSwiper) {
					swiperADAduplicatedProcess(currentSwiper);
				},
			},
			pagination: {
				el: `.swiper-pagination-${i}`,
				clickable: true,
				renderBullet: function (index, className) {
					return `<span class="swiper-pagination-bullet">${index + 1}</span>`;
				},
			}
		};

		let combinedOps = Object.assign({}, swiperOps, dataOps);

		let sliderDots = document.createElement('div');
		sliderDots.classList.add("swiper-pagination",`swiper-pagination-${i}`);

		slider.setAttribute(`data-swiper${i}`, '');

		if(slider.classList.contains('has-swiper-dots')) {
			slider.appendChild(sliderDots);
		}
		const swiper = new Swiper(`[data-swiper${i}]`, combinedOps);

		swiper.on('slideChange', (currentSwiper) => {
			swiperADAduplicatedProcess(currentSwiper);
		});
	});

	//Mobile Submenu Funcionality
	document.querySelectorAll('.burger-menu__nav > li > a').forEach(link => {
		link.addEventListener('click', e => {
			if (link.nextSibling.nextSibling != null) {
				document.querySelectorAll('.inner > ul > li').forEach(item => {
					if (link.parentNode !== item) item.classList.remove('submenu-show');
				});
				e.preventDefault();
				link.parentNode.classList.toggle('submenu-show');
			}
		});
	});

	//add class for icon dropdown 
	document.querySelectorAll('.burger-menu__nav > li > .sub-sub-menu').forEach(link => {
		let menu = link.parentNode.firstElementChild;
		menu.classList.add('icon-dropdown');
	});

	/* Lightbox Gallerys */
	const customLightbox = new LBX('.js-lbx-gallery', {
		customClass:'lbx-gallery',
	});

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		// downscroll code
		if(!document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.add('scroll');
			changeSrc(headerLogo.getElementsByTagName('img')[0]);
		}
	} else {
		if(document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.remove('scroll');
			changeSrc(headerLogo.getElementsByTagName('img')[0]);
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}



function onLoad(){

	convertBtn();
	//Check anchor on URL
	let anchorHref = window.location.href;
	if(anchorHref.indexOf('#') > 0){
		if(anchorHref.split('#').length === 2){
			let windowTarget = anchorHref.split('#')[1];
			if(document.getElementById(windowTarget)){
				setTimeout(() => {
					animateTo(windowTarget);
				}, 600);
			}
		}
	}

	if(!document.getElementById('gallery') && !document.getElementById('attractions') && document.getElementsByClassName('sitemap').length < 1 && document.getElementsByClassName('terms-and-conditions').length < 1 && document.getElementsByClassName('no-hero').length < 1){
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	} else {
		document.getElementById('header').classList.add('scroll');
		changeSrc(headerLogo.getElementsByTagName('img')[0]);
	}
}

function convertBtn() {
	if (document.getElementsByClassName('btn').length > 0) {
		let ALL_BTNS = document.querySelectorAll('.btn');
		ALL_BTNS.forEach((btn) => {
			if (btn.getAttribute('type') !== 'submit') {
				let INNER_TEXT = btn.innerHTML;
				btn.innerHTML = '<span>' + INNER_TEXT + '</span>';
			}
		});
	}
}

//vanilla js scroll TO animation
function animateTo(target) {
	var gotoTarget = offset(document.getElementById(target)).top - 250;
	var from = window.pageYOffset;
	var to = gotoTarget;
	var duration = 1300;
	var start = new Date().getTime();

	//time interval
	var timer = setInterval(function () {
		var time = new Date().getTime() - start;

		if (from <= to) {
			var y = easeInOutQuart(time, from, to - from, duration);
		} else {
			var y = easeInOutQuart(time, from, -(from - to), duration);
		}
		window.scrollTo(0, y);
		if (time >= duration) clearInterval(timer);
	}, 1000 / 60);

	window.scrollTo(0, from);
}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b;
	return (-c / 2) * ((t -= 2) * t * t * t - 2) + b;
}

function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}

function changeSrc(elem) {
	let target = elem.getAttribute('data-scroll');
	let currentSrc = elem.getAttribute('src');

	elem.setAttribute('src', target);
	elem.setAttribute('data-scroll', currentSrc);
}

function setUpBooking() {
	
	$('#bookingCalendar').datepicker({
		changeMonth: false,
		minDate:0,
		dateFormat: 'mm-dd-yy',
		numberOfMonths: 2,
		monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], 
		beforeShowDay: function (date) {
			$.datepicker._defaults.dateFormat = "mm-dd-yy";
			
			var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
			var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
			if (date.getTime() == startDate.getTime()) {
				return [true, "startday"];
			} else {
				if (date.getTime() == endDate.getTime()) {
					return [true, "endday"];
				} else {
					if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
						return [true, "days"];
					} else {
						return [true, ""];
					}
				}
			}
		},
		onSelect: function (date) {
			var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
			var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
			var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);
			
			if (opened == 0) {
				opened = 1;
				start = date;
				end = date;
			} else {
				opened = 0;
				if (selectedDate <= arrive) {
					end = start;
					start = date;
				} else {
					end = date;
				}
			} 
			$('#altDates').attr('value',start +'/'+end);
			
			var NewStart = start.split("-");
			NewStart.unshift(NewStart.pop());
			NewStart = NewStart.join('-')
			
			var NewEnd = end.split("-");
			NewEnd.unshift(NewEnd.pop());
			NewEnd = NewEnd.join('-')
			
			$('#arriveInput').attr('value',NewStart);
			$('#departureInput').attr('value',NewEnd);
		}
	});
}
